import React from 'react'
import Menubar from '../components/Menubar/Menubar'
import Offer from '../components/Offers/Offers'

function Menu() {
  return (
    <div>
        <Menubar/>
        <Offer/>
        
      
    </div>
  )
}

export default Menu
